import WesleyChapelHeroSection from "./components/HeroSection";
import WesleyChapelStickyNav from "./components/StickyNav";
import WesleyChapelProcessingTimeSection from "./components/ProcessingTimeSection";
import WesleyChapelServicesSection from "./components/ServicesSection";
import WesleyChapelLocalAreaSection from "./components/LocalAreaSection";
import WesleyChapelTravelTimingSection from "./components/TravelTimingSection";
import WesleyChapelDestinationsSection from "./components/DestinationsSection";
import WesleyChapelTestimonialsSection from "./components/TestimonialsSection";
import WesleyChapelAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WesleyChapelComparisonSection from "./components/ComparisonSection";
import WesleyChapelMistakesSection from "./components/MistakesSection";
import WesleyChapelHowItWorksSection from "./components/HowItWorksSection";
import WesleyChapelFAQSection, { faqs } from "./components/FAQSection";
import WesleyChapelHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WesleyChapelFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function WesleyChapelPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Wesley Chapel"
        state="Florida"
        stateAbbr="FL"
        route="/cities/wesley-chapel"
        title="Emergency Passport Wesley Chapel, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Wesley Chapel, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Pasco County families, Wiregrass Ranch residents, and Tampa Bay travelers."
        geoPlacename="Wesley Chapel, Florida"
        geoPosition="28.2394;-82.3279"
        faqs={faqs}
        servicesSchema={servicesList}
      />
      <WesleyChapelHeroSection />
      <WesleyChapelStickyNav />
      <WesleyChapelProcessingTimeSection />
      <WesleyChapelServicesSection />
      <WesleyChapelLocalAreaSection />
      <WesleyChapelTravelTimingSection />
      <WesleyChapelDestinationsSection />
      <WesleyChapelTestimonialsSection />
      <WesleyChapelAcceptanceFacilitiesSection />
      <WesleyChapelComparisonSection />
      <WesleyChapelMistakesSection />
      <WesleyChapelHowItWorksSection />
      <WesleyChapelFAQSection />
      <WesleyChapelHelpfulResourcesSection />
      <WesleyChapelFinalCTA />
    </div>
  );
}